import { LeftOutlined, RightOutlined, SearchOutlined } from '@ant-design/icons';
import { Button, Col, Flex, Card, Row, Input, Space, Alert, Spin } from "antd";
import _ from 'lodash-es';
import {useState} from "react";
import intl from 'react-intl-universal';
import request from "../../../libs/request";
import Evisit from "../../../libs/Evisit";

const SearchPatient = ({currentComponent, onNext, onPrevious, data, isMobileWebview}) => {

    const [loading, setLoading] = useState(false);
    const [patients, setPatients] = useState([]);
    const [searching, setSearching] = useState(false);
    const [selectedPatient, setSelectedPatient] = useState(null);
    const [error, setError] = useState(null);

    const onSearch = (keyword) => {
        setSearching(true);
        setError(null);
        request.get(`${window.base_url}/api_v3/users`, {
            params: {
                search: keyword,
                type: "member",
                fields: "full_name,dob,email,phone,code,is_private"
            }
        }).then(response => {
            const filterPatients = filterPatientsPrivateResult(_.get(response, "data", []), keyword);
            setPatients(filterPatients);
        }).catch(error => {
            setError(_.get(error, "response.data.message", "Something went wrong."));
            setPatients([]);
        }).finally(() => {
            setSearching(false);
        });
    }

    const filterPatientsPrivateResult = (patients = [], keyword = '') => {
        return patients.filter(item => {
            if (item.is_private) {
                if (item.full_name.toLowerCase() !== keyword.trim().toLowerCase()) {
                    return false;
                }
                item.dob = '####';
                item.email = '####';
                item.phone = '####';
            }
            return true;
        });
    }

    const onSelectPatient = (patient) => {
        setSelectedPatient(patient);
    }

    const renderPatientList = () => {
        var results = [];
        for (const i in patients) {
            var selectedClass = (selectedPatient && selectedPatient["id"] && selectedPatient["id"] === patients[i]["id"]) ? "selected patient" : "patient";
            var userProfile = [];
            if (patients[i]["email"]) {
                userProfile.push(patients[i]["email"]);
            }
            if (patients[i]["phone"]) {
                userProfile.push(patients[i]["phone"]);
            }
            if (patients[i]["dob"]) {
                userProfile.push(patients[i]["dob"]);
            }
            results.push(
                <Card
                    key={ patients[i]["id"] }
                    className={ selectedClass }
                    onClick={ () => onSelectPatient(patients[i]) }
                >
                    <p>{ patients[i]["full_name"] }</p>
                    <span>{ userProfile.join(", ") }</span>
                </Card>
            )
        }
        return (<Space className="patient-list" direction="vertical" style={{width: "100%"}}>
            { results }
        </Space>);
    }

    const onCreate = () => {
        Evisit.executeActions("create_patient", currentComponent, {data: {}}, data).then(response => {
            onNext({});
        });
    }

    const onSubmit = () => {
        setLoading(true);
        Evisit.executeActions("submit", currentComponent, {data: selectedPatient}, data).then(response => {
            onNext(selectedPatient);
            setLoading(false);
        });
    }

    return (
        <Space id="SearchPatient" className="search-patient" direction="vertical" size="middle" style={{ display: 'flex' }}>
            <Input
                size="large"
                placeholder={ intl.get("search_patient").d("Search by patient's name") }
                prefix={<SearchOutlined />}
                onChange={_.debounce(e => {
                    if (e.target.value.length > 2) {
                        onSearch(e.target.value);
                    } else if (e.target.value.length > 0) {
                        setError(intl.get("min_input", {num: 3}).d("Please enter at least {num} characters"));
                    }
                }, 700)}
            />
            {
                searching ? <>
                    <div className="align-center">
                        <Spin size="large" />
                    </div>
                </> : <>
                    {error && <Alert message={ error } type="error" />}
                    {patients.length > 0 && <>
                        <b>{ intl.getHTML("search_patient_result", {n: patients.length}).d("Found <span class='color-emphasis'>{n} possible matches</span> for patient account") }</b>
                        { renderPatientList(patients, selectedPatient) }
                    </>}
                </>
            }
            <Row>
                <Col span={24}>
                    <Flex justify={isMobileWebview ? "center" : "space-between"}>
                        { (onPrevious != null && !isMobileWebview) ?
                            <Button onClick={ onPrevious }>
                                <LeftOutlined style={{verticalAlign:"middle"}} />
                                { intl.get("back").d("Back") }
                            </Button> : <div></div>
                        }
                        <Space direction="horizontal">
                            <Button
                                data-event="create_patient"
                                onClick={() => onCreate()}
                            >
                                { intl.get("create_new_patient").d("Create new patient") }
                            </Button>
                            <Button
                                type="primary"
                                shape={isMobileWebview ? "round" : "default"}
                                size={isMobileWebview ? "large" : "default"}
                                disabled={selectedPatient === null}
                                loading={loading}
                                onClick={onSubmit}
                            >
                                {intl.get("continue").d("Continue")}
                                <RightOutlined style={{verticalAlign:"middle"}} />
                            </Button>
                        </Space>
                    </Flex>
                </Col>
            </Row>
        </Space>
    );
}

export default SearchPatient;